import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export const Navigation = _ref => {
  let {
    accountType,
    page,
    claim,
    project
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    variant: "tabs"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'employees_bio',
    to: `/${accountType}/claims/${claim.id}/financial_details/employees_bio`
  }, t('employee_bio'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'employees_activity',
    to: `/${accountType}/claims/${claim.id}/projects/${project.id}/financial_details/employees_activity`
  }, t('employee_activity'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'wages',
    to: `/${accountType}/claims/${claim.id}/projects/${project.id}/financial_details/wages`
  }, t('staffing_costs'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'contractors',
    to: `/${accountType}/claims/${claim.id}/projects/${project.id}/financial_details/contractors`
  }, t('contractors'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'total_costs',
    to: `/${accountType}/claims/${claim.id}/financial_details/total_costs`
  }, t('total_costs')))));
};